import Ecommerce from "../../services/EcommerceServices";

const state = {
    listEcommerce: []
};
const getters = {
    listEcommerce: (state) => {
      return state.list;
    },
  }
  const actions = {
    getListEcommerce() {
      return Ecommerce.getList({})
    },
    setListEcommerce(context, data) {
      context.commit("SET_LIST", { data });
    },
  }
  const mutations = {
    SET_LIST_ECOMMERCE(state, { data: data }) {
      state.listEcommerce = data;
    },
  }
  export default {
    state,
    getters,
    actions,
    mutations,
  };
  